export default __webpack_public_path__ + "74a12cd1a511df89ee2107cdb773e478.png";